import AnalyticsEvent from './AnalyticsEvent';

class ActionStatus extends AnalyticsEvent {
	constructor(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent) {
		super(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent);
		this.className = 'ActionEvent';
		this.dbDest = 'action_status';
		this._view = '';
		this._castId = '';
		this._videoId = '';
		this._socialId = '';
		this._timecode = -1;
		this._response = '';
		this._type = '';
	}

	appendBaseParams(uId, d) {
		this.append(uId, d);
	}


	appendOptionParams() {
		/*switch (this.simulatedURL) {
		  case ActionStatusEvent.GESTURE_RESPONSE:
			this.extraParams += '&response=' + this.response;
		  break;
		}
		*/
	}

}

Object.defineProperty(ActionStatus.prototype, 'gaEventSet', {
	get: function () {
		let urlComps = this.simulatedURL.split('_');
		this._gaEventSet.category = urlComps[0];
		this._gaEventSet.action = urlComps[1];
		this._gaEventSet.label = urlComps[2];
		urlComps.length > 3 ? this._gaEventSet.value = urlComps[4] : null;

		return this._gaEventSet;
	}
});

Object.defineProperty(ActionStatus.prototype, 'timecode', {
	set: function (tcode) {
		this._timecode = tcode;
		this._gaEventSet.value = this._timecode;
		this.appendOptionParams();
		this.simulatedURL = this.simulatedURL.replace('[secs]', this._timecode);
	},
	get: function () { return this._timecode; }
});


Object.defineProperty(ActionStatus.prototype, 'view', {
	set: function (view) {
		this._view = this.ucfirst(view);
		this.simulatedURL = this.simulatedURL.replace('[view]', this._view);
	},
	get: function () { return this._view; }
});

Object.defineProperty(ActionStatus.prototype, 'type', {
	set: function (type) {
		this._type = this.ucfirst(type);
		this.simulatedURL = this.simulatedURL.replace('[type]', this._type);
	},
	get: function () { return this._type; }
});

Object.defineProperty(ActionStatus.prototype, 'video_id', {
	set: function (vidId) {
		this._videoId = vidId;
		this.simulatedURL = this.simulatedURL.replace('[video_id]', this._videoId);
	},
	get: function () { return this._videoId; }
});

Object.defineProperty(ActionStatus.prototype, 'social_id', {
	set: function (social) {
		this._socialId = social;
		this.simulatedURL = this.simulatedURL.replace('[social_id]', this._socialId);
	},
	get: function () { return this._socialId; }
});

Object.defineProperty(ActionStatus.prototype, 'cast_id', {
	set: function (castId) {
		this._castId = castId;
		this.simulatedURL = this.simulatedURL.replace('[cast_id]', this._castId);
	},
	get: function () { return this._castId; }
});

export default ActionStatus;


// WEBPACK FOOTER //
// ./src/analytics/analytics-events/ActionStatus.js